<template>
    <div class="d-flex align-items-center" style="height: 35px" >
        <feather-icon
            v-for="star in valuesRating"
            :key="star.nota"
            icon="StarIcon"
            @mouseover="actionMouseOver(star)"
            @mouseleave="actionMouseLeave"
            @click="setFinalRating(star)"
            :size="star.nota == rating && mouseOver ? '35' : '30'"
            :class="[{'fill-current': star.nota <= rating}, star.nota <= rating ? 'text-custom-blue' : 'text-custom-blue']"
            :style="{ strokeWidth: '1.2' }"
        />
        <h5 class="m-0 pl-1">
            {{ descriptionStar }}
        </h5>
    </div>
  </template>
  
  <script>

  export default {
    data: () => ({
        rating: 0,
        finalRating: 0,
        descriptionStar: null,
        valuesRating: [],
        mouseOver: false
    }),
    mounted() {
        this.fillRatingStars()
    },
    methods: {
        setFinalRating(star) {
            this.finalRating = star
            this.$emit('finalRating', this.finalRating)
        },
        async fillRatingStars(){
            const { data } = await this.$http.get(this.$api.avaliacaoMetrica());
            this.valuesRating = data
        },
        actionMouseLeave(){
            this.rating = this.finalRating?.nota
            this.descriptionStar = this.finalRating?.descricao
            this.mouseOver = false
        },
        actionMouseOver(star) {
            this.rating = star.nota
            this.descriptionStar = star.descricao
            this.mouseOver = true
        }
    }
  };
  </script>